import { Component } from 'react';
import { Button } from './ui/button';
import { AlertTriangle, RotateCcw, Home } from 'lucide-react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
          <AlertTriangle className="h-16 w-16 text-destructive/50 mb-4" />
          <h2 className="text-2xl font-semibold mb-2">Une erreur est survenue</h2>
          <p className="text-muted-foreground mb-2 max-w-md">
            L'application a rencontré un problème inattendu.
          </p>
          <p className="text-xs text-muted-foreground mb-8 font-mono max-w-lg truncate">
            {this.state.error?.message}
          </p>
          <div className="flex gap-3">
            <Button variant="outline" className="gap-2"
              onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}>
              <RotateCcw className="h-4 w-4" /> Recharger
            </Button>
            <Button className="gap-2" onClick={() => { this.setState({ hasError: false, error: null }); window.location.href = '/'; }}>
              <Home className="h-4 w-4" /> Accueil
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
